module.exports = __webpack_public_path__ + "img/c03_unitswanship_Normal_ua.fc585e2b.webp";